// extracted by mini-css-extract-plugin
export var redoItem = "_l8-1";
export var redoTrigger = "_l8-0";